import React from 'react'
import Tooltip from './components/Tooltip'

class UploadButton extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    onUpload = () => {
        const { name, id, onUpdate, payload, openAssetManager } = this.props

        openAssetManager(data => onUpdate(id, { [name]: data.src }, payload))
    }

    onDelete = () => {
        const { name, id, onUpdate, payload } = this.props

        onUpdate(id, { [name]: '' }, payload)
    }

    render() {
        const {
            tooltipText,
            value,
            schema: { label = '' },
        } = this.props

        return (
            <div className="control-box">
                <p className="label">
                    {label}
                    {<Tooltip tooltipText={tooltipText} />}
                </p>
                <div className="content upload">
                    {value ? <div className="preview" style={{ backgroundImage: `url(${value})` }}></div> : null}
                    <button className="upload-btn" onClick={() => this.onUpload()}>
                        {value ? 'Change' : 'Upload'}
                    </button>
                    {value ? <button className="remove" onClick={() => this.onDelete()}></button> : null}
                </div>
            </div>
        )
    }
}

export default UploadButton
